import {Kind} from "graphql";

export default function (typeDefs, type, handler) {
    // This is not a valid directive
    // For internal use only
    const directive = {
        kind: Kind.DIRECTIVE,
        name: {kind: Kind.NAME, value: 'handleInput'},
        arguments: [{
            kind: Kind.ARGUMENT,
            name: {kind: Kind.NAME, value: 'handler'},
            value: {kind: 'FunctionValue', value: handler, block: false}
        }]
    }
    const typeIndex = typeDefs.definitions.findIndex(d => d.name?.value === type);
    typeDefs.definitions[typeIndex].directives.push(directive);
    return typeDefs;
}
